
import { Component, Vue } from "vue-property-decorator";
import { catalogService } from "@/services/api/catalogs.service";
import { getModule } from "vuex-module-decorators";
import AuthModule from "@/store/modules/core/auth.module";
import store from "@/store";
import moment from "moment";
const authModule = getModule(AuthModule, store);
const AppBar = () => import("@/components/core/AppBar.vue");
const AppFooter = () => import("@/components/core/AppFooter.vue");
const MessageDialog = () => import("@/components/core/MessageDialog.vue");

@Component({
  components: {
    AppBar,
    AppFooter,
    MessageDialog,
  },
})
export default class CatalogsUpdate extends Vue {
  // VARS
  private isLoading = false;
  private daysDifference = 15;
  private daysDifferenceCatalogs = 15;

  private headers = [
    { text: "Catalogo", value: "sourceDescription" },
    { text: "Agg. Catalogo", value: "catalogueUpdateDate" },
    { text: "Agg. Prezzi", value: "priceUpdateDate" },
    { text: "Agg. Stock", value: "stockUpdateDate" },
    { text: "Agg. Foto", value: "photoUpdateDate" },
  ];
  private set = [];

  // VARS --- COMPONENTS
  private numberSelected = 0;
  private messageDialogOpen = false;
  private dialogText = "";
  private beforeCreate(): void {
    if (authModule.role != "0") {
      this.$router.push("/");
    }
  }

  mounted(): void {
    this.refreshTable();
  }

  // METHODS --- POPULATE TABLE
  private refreshTable(): void {
    this.isLoading = true;
    // API here
    catalogService.getCatalogsUpdateDates().then((res) => {
      this.set = res.data;
      this.isLoading = false;
    });
  }

  // METHODS --- COLOR CHIP PROPERLY
  private colorChip(dateString: string, useCatalogueDays = false): string {
    // If date is older than x days, then color red, else green.
    if (useCatalogueDays) {
      return Math.abs(moment(dateString).diff(moment(), "days")) >
        this.daysDifferenceCatalogs
        ? "red"
        : "green";
    }
    return Math.abs(moment(dateString).diff(moment(), "days")) >
      this.daysDifference
      ? "red"
      : "green";
  }

  private prepDate(dateString: string): string {
    return dateString.replace("T", " ").split(":").slice(0, -1).join(":");
  }
}
